import { render, staticRenderFns } from "./Nueva_reserva.vue?vue&type=template&id=9c300ce0"
import script from "./Nueva_reserva.vue?vue&type=script&lang=js"
export * from "./Nueva_reserva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports